"use client";

import { useParams } from "next/navigation";

export function useAppLocale(): string {
  const params = useParams();

  // Extract the locale from the url (app/[locale]/...)
  // Fallback to "en" just in case it's used outside a locale boundary
  return (params?.locale as string) || "en";
}
